import Vue from "vue";
import btnAccess from "@/components/buttons/btnAccess";
import dialogDefault from "@/components/dialogs/dialogDefault";
import timePickerDialog from "@/components/dialogs/timePickerDialog";
import datePickerDialog from "@/components/dialogs/datePickerDialog";
import dialogConfirm from "@/components/dialogs/dialogConfirm";
import tableGridDefault from "@/components/dataTables/tableGridDefault";
import selectTable from "@/components/selects/selectTable";
import alertBox from "@/components/alerts/alertBox";
import timePicker from "@/components/pickers/timePicker";
import autoCompleteEntity from "@/components/autoCompletes/autoCompleteEntity";
import colorPickerDialog from "@/components/dialogs/colorPickerDialog";
import kanban from "@/components/kanban/kanban";
import localeSelect from "@/components/locales/localeSelect";
import dateTimePickerDialog from "@/components/dialogs/dateTimePickerDialog";
import objectValueList from "@/components/lists/objectValueList";
import entityFieldCustomAutoForm from "@/components/forms/entityFieldCustoms/entityFieldCustomAutoForm";
import regSearch from "@/components/registries/regSearch";
import basicHistory from "@/components/forms/entities/basicHistory";
import snackBarGlobal from "@/components/snackBars/snackBarGlobal";
import actionMenu from "@/components/menus/actionMenu"
import tableDynamic from "@/components/dataTables/tableDynamic"
import statusColor from "@/components/status/statusColor"

// css
import "../assets/css/kanban/kanban.css";
import "../../node_modules/flag-icon-css/css/flag-icon.min.css";

export default () => {
  // components

  Vue.component("entity-field-custom-autoform", entityFieldCustomAutoForm)
  Vue.component("object-value-list", objectValueList);
  Vue.component("datetime-picker-dialog", dateTimePickerDialog);
  Vue.component("btn-a", btnAccess);
  Vue.component("dialog-d", dialogDefault);
  Vue.component("dialog-c", dialogConfirm);
  Vue.component("date-dialog", datePickerDialog);
  Vue.component("time-dialog", timePickerDialog);
  Vue.component("time-picker", timePicker);
  Vue.component("alert-box", alertBox);
  Vue.component("table-grid", tableGridDefault);
  Vue.component("select-table", selectTable);
  Vue.component("color-dialog", colorPickerDialog);
  Vue.component("kanban-board", kanban);
  Vue.component("locale-select", localeSelect);
  Vue.component("auto-complete-entity", autoCompleteEntity);
  Vue.component("reg-search", regSearch);
  Vue.component("basic-history", basicHistory);
  Vue.component("notification", snackBarGlobal);
  Vue.component("action-menu", actionMenu);
  Vue.component("table-dynamic", tableDynamic);
  Vue.component("status-color", statusColor);
};
